/* List of Redux constants */
export const VACANCY_DOCUMENTS_SET_FORM_LOADING = '@vacancy-documents/set-loading';
export const VACANCY_DOCUMENTS_SET_DOCUMENT_ADDING = '@vacancy-documents/set-document-adding';
export const VACANCY_DOCUMENTS_SET_DOCUMENT_REMOVING = '@vacancy-documents/set-document-removing';
export const VACANCY_DOCUMENTS_SET_DOCUMENT_UPDATING = '@vacancy-documents/set-document-updating';
export const VACANCY_DOCUMENTS_SET_VACANCY_DOCUMENTS = '@vacancy-documents/set-vacancy-documents';
export const VACANCY_DOCUMENTS_RESET_STATE = '@vacancy-documents/reset-state';
export const VACANCY_DOCUMENTS_SET_NEW_VACANCY_DOCUMENT = '@vacancy-documents/set-new-vacancy-document'

/* List of Sagas constants */
export const VACANCY_DOCUMENTS_GET_VACANCY_DOCUMENTS = '@vacancy-documents/get-vacancy-documents';
export const VACANCY_DOCUMENTS_DELETE_VACANCY_DOCUMENT = '@vacancy-documents/delete-vacancy-document';
export const VACANCY_DOCUMENTS_UPDATE_VACANCY_DOCUMENT = '@vacancy-documents/update-vacancy-document';
export const VACANCY_DOCUMENTS_ADD_VACANCY_DOCUMENT = '@vacancy-documents/add-vacancy-document';



// WEBPACK FOOTER //
// ./src/actions/vacancies/vacancy-documents/types.js